import { stringParser } from '../inboundParsers';
export const LOBBY_GENERIC_CHAT_PAYLOAD_DEFINITION = {
    isRawParam: true,
    definitionParts: [{ name: 'html', parser: stringParser }]
};
